export default "__VITE_ASSET__BWnT1Mtr__"